import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Cart from './cart'

class CartItemsBlock extends BaseComponent {
  cart: Nullable<Cart>

  constructor() {
    super()

    this.cart = this.closest('cart-page')
  }

  connectedCallback(): void {
    if (this.cart) {
      this.cart.subscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cart) {
      this.cart.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  handleFinishCartUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const blockId = this.getAttribute('block-id')
    const newItems = node.querySelector(
      `cart-items-block[block-id="${blockId}"]`,
    )

    if (!newItems) {
      return
    }

    const clonedNewItems = newItems.cloneNode(true)

    this.replaceChildren(...clonedNewItems.childNodes)

    this.scrollIntoView({ behavior: 'smooth' })
  }
}

export default CartItemsBlock
